import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Categories from "./components/Categories";
import Works from "./components/Works";
import Experience from "./components/Experience";
import Brand from "./components/Brand";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Categories />
        <Works />
        <Experience />
        <Brand />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}